import { killshotApi } from '../api';

const NOTES_BASE_PATH = '/v1/notes';

export const createNotes = async data => {
  await killshotApi.post(NOTES_BASE_PATH, {
    source_type: data.sourceType,
    entity_type: data.entityType,
    entity_id: data.entityID,
    note_type: data.noteType,
    user_version: data.userVersion,
    content: data.note,
    pinned: false,
    standardize_note: data.standardizeNote || false,
  });
};

export const createStandardizeNotes = async data => {
  const zoneData = data.selectedZones.map(zone => ({
    zone,
    avg_price: data.zoneData[zone].avgSalesPrice,
    total_sales: data.zoneData[zone].totalSales,
  }));

  // Build zone information string
  const zoneInfoString = data.selectedZones
    .map(zone => {
      const zoneInfo = data.zoneData[zone];
      return `DIQ Zone: ${zone}
Average Sales Price: $${zoneInfo.avgSalesPrice}
Total Sales: ${zoneInfo.totalSales}`;
    })
    .join('\n');

  const noteContent = `Current Period: ${data.currentPeriod}
${data.endpoint ? `Endpoint: ${data.endpoint}%` : ''}
Sold %: ${data.soldPercentage}
Action: ${data.action}
Pricing Strategy: ${data.pricingStrategy}${data.withCeiling ? `\n Ceiling: ${data.ceilingReason}` : ''}
Primary Quantity Status: ${data.primaryQuantityStatus}
PM Drops/Cuts: ${data.pmDropsCuts}
Get-in: $${data.getInPrice}${data.bidPriceDelta ? `\nBid Price Delta: ${data.bidPriceDelta}%` : ''}${
    data.kobeSelloutDTE ? `\nKobe Sellout DTE: ${data.kobeSelloutDTE}` : ''
  }
${data.dataIQSales ? `Data IQ Running Sales: ${data.dataIQSales}` : ''}
${zoneInfoString}`;

  await killshotApi.post(NOTES_BASE_PATH, {
    source_type: data.sourceType,
    entity_type: data.entityType,
    entity_id: data.entityID,
    note_type: data.noteType,
    user_version: data.userVersion,
    content: noteContent,
    pinned: false,
    standardize_note: true,
    action: data.action,
    current_period: data.currentPeriod,
    data_iq_sales: data.dataIQSales,
    get_in_price: data.getInPrice,
    bid_price_delta: data.bidPriceDelta,
    kobe_sellout_dte: data.kobeSelloutDTE,
    pm_drops_cuts: data.pmDropsCuts,
    primary_quantity_status: data.primaryQuantityStatus,
    sold_percentage: data.soldPercentage,
    endpoint: data.endpoint ? data.endpoint : null,
    pricing_strategy: data.pricingStrategy,
    ceiling: data.withCeiling ? data.ceilingReason : null,
    data_iq: zoneData,
  });
};

export const updateReadNotes = async data => {
  await killshotApi.put(`${NOTES_BASE_PATH}/update_read`, {
    entity: data.entityID,
    user_version: data.userVersion,
    reader_email: data.email,
  });
};

export const updatePin = async data => {
  await killshotApi.put(`${NOTES_BASE_PATH}/update_pinned`, {
    entity: data.entityID,
    user_version: data.userVersion,
    pinned: data.pinned,
  });
};

export const updateReadJournalRecords = async data => {
  const url = `v1/journal/${data.eventId}/journal_views`;
  await killshotApi.post(url, {
    journal_ids: data.journalIds,
  });
};

export const putGroupsPosition = async (data, eventId) => {
  const url = `v1/groups/update_group_position`;
  await killshotApi.put(url, {
    event_id: parseInt(eventId, 10),
    new_groups_positions: data,
  });
};

export const putEventGroupsSortingCriteria = async data => {
  const url = `v1/event/sorting_criteria/${data.eventId}`;
  await killshotApi.post(url, {
    sorting_criteria: data.sorting_criteria,
    position: data.position,
  });
};

export const updateEvent = async (data, eventId) => {
  const url = `v1/event/${eventId}`;
  await killshotApi.put(url, data);
};

export const updateGroupMarketplace = async (data, eventId, groupId) => {
  const url = `v1/event/${eventId}/groups/${groupId}`;
  await killshotApi.put(url, data);
};

export const fetchAutoPricerIntervals = async () => {
  const response = await killshotApi.get(`v1/auto_pricer/intervals`);
  return response;
};
